import { useSyncExternalStore } from "react";

/** Web: whether a CSS media query matches now, following changes. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (changed) => {
      const mq = window.matchMedia(query);
      mq.addEventListener("change", changed);
      return () => mq.removeEventListener("change", changed);
    },
    () => window.matchMedia(query).matches,
  );
}
